// Constants for filter menu
export const connectionStateValues = ['offline', 'online', 'reset'];
export const demandValues = ['is_fan_running', 'is_occupied'];
export const fanSettingValues = ['auto', 'on', 'off'];
export const modeValues = ['cool', 'eco', 'heat', 'off', 'auto', 'auxHeatOnly', 'heat_cool'];
export const buildingSectionValues = ['top', 'middle', 'bottom'];
export const directionValues = [
  'north',
  'north_east',
  'north_west',
  'west',
  'east',
  'south_east',
  'south_west',
  'south',
];
export const stateValues = ['heat', 'cool', 'aux_heat', 'off'];

export const connectionState = [
  {
    filter: 'online',
    filterDisplay: 'Online',
    countKey: 'onlineCount',
    key: 'onlineFilter',
  },
  {
    filter: 'offline',
    filterDisplay: 'Offline',
    countKey: 'offlineCount',
    key: 'offlineFilter',
  },
  {
    filter: 'reset',
    filterDisplay: 'Reset',
    countKey: 'resetCount',
    key: 'resetFilter',
  },
];

export const mode = [
  {
    filter: 'cool',
    filterDisplay: 'Cool',
    countKey: 'coolModeCount',
    key: 'coolFilter',
  },
  {
    filter: 'heat',
    filterDisplay: 'Heat',
    countKey: 'heatModeCount',
    key: 'heatFilter',
  },
  {
    filter: 'off',
    filterDisplay: 'Off',
    countKey: 'offModeCount',
    key: 'offFilter',
  },
  {
    filter: 'auto',
    filterDisplay: 'Auto',
    countKey: 'autoModeCount',
    key: 'autoFilter',
  },
  {
    filter: 'auxHeatOnly',
    filterDisplay: 'Aux Heat',
    countKey: 'auxHeatOnlyModeCount',
    key: 'auxHeatOnlyFilter',
  },
  // Nest-Only Modes
  // {
  //   filter: 'ecoMode',
  //   filterDisplay: 'Eco',
  //   countKey: 'ecoCount',
  //   key: 'ecoFilter',
  // },
  // {
  //   filter: 'heatCoolMode',
  //   filterDisplay: 'Heat-Cool',
  //   countKey: 'heatCoolCount',
  //   key: 'heatCoolFilter',
  // },
];

export const fanMode = [
  {
    filter: 'on',
    filterDisplay: 'On',
    countKey: 'fanOnCount',
    key: 'fanOnFilter',
  },
  {
    filter: 'auto',
    filterDisplay: 'Auto',
    countKey: 'fanAutoCount',
    key: 'fanAutoFilter',
  },
  {
    filter: 'off',
    filterDisplay: 'Off',
    countKey: 'fanOffCount',
    key: 'fanOffFilter',
  },
];

export const states = [
  {
    filter: 'off',
    filterDisplay: 'Off',
    countKey: 'offStateCount',
    key: 'offStateFilter',
  },
  {
    filter: 'cool',
    filterDisplay: 'Cooling',
    countKey: 'coolingStateCount',
    key: 'coolingStateFilter',
  },
  {
    filter: 'heat',
    filterDisplay: 'Heating',
    countKey: 'heatingStateCount',
    key: 'heatingStateFilter',
  },
  {
    filter: 'aux_heat',
    filterDisplay: 'Aux Heating',
    countKey: 'auxHeatingStateCount',
    key: 'auxHeatingStateFilter',
  },
];

export const demand = [
  {
    filter: 'is_fan_running',
    filterDisplay: 'Fan Active',
    countKey: 'fanActiveCount',
    key: 'fanActiveFilter',
  },
  {
    filter: 'is_occupied',
    filterDisplay: 'Occupied',
    countKey: 'occupiedCount',
    key: 'occupiedFilter',
  },
];

export const buildingSection = [
  {
    filter: 'top',
    filterDisplay: 'Top',
    key: 'topFilter',
  },
  {
    filter: 'middle',
    filterDisplay: 'Middle',
    key: 'middleFilter',
  },
  {
    filter: 'bottom',
    filterDisplay: 'Bottom',
    key: 'bottomFilter',
  },
];

export const rowOne = [
  {
    filter: 'north_west',
    filterDisplay: 'NW',
    key: 'nwFilter',
  },
  {
    filter: 'north',
    filterDisplay: 'N',
    key: 'nFilter',
  },
  {
    filter: 'north_east',
    filterDisplay: 'NE',
    key: 'neFilter',
  },
];

export const rowTwo = [
  {
    filter: 'west',
    filterDisplay: 'W',
    key: 'wFilter',
  },
  {
    filter: 'east',
    filterDisplay: 'E',
    key: 'eFilter',
  },
];

export const rowThree = [
  {
    filter: 'south_west',
    filterDisplay: 'SW',
    key: 'swFilter',
  },
  {
    filter: 'south',
    filterDisplay: 'S',
    key: 'sFilter',
  },
  {
    filter: 'south_east',
    filterDisplay: 'SE',
    key: 'seFilter',
  },
];
